// src/components/common/ImageUploader.js
import React from "react";
import useImageUpload from "../hooks/useImageUpload";

export default function ImageUploader({ label = "Upload Image", onImageChange, savedImage = null }) {
	const { image, previewUrl, fileInputRef, handleImageChange, resetImage } = useImageUpload();

	// Called only when user selects a file or clears it (no effect loop)
	const onInputChange = (e) => {
		const file = handleImageChange(e); // sets internal state inside hook
		if (typeof onImageChange === "function") {
			onImageChange(file); // notify parent exactly once per user action
		}
	};

	const handleClear = () => {
		resetImage();
		if (typeof onImageChange === "function") onImageChange(null);
	};

	return (
		<div className="mb-3">
			{label && <label className="form-label">{label}</label>}

			<div className="d-flex align-items-center position-relative">
				<input
					type="file"
					className="form-control bg-dark text-light pe-5"
					accept="image/jpeg, image/png"
					onChange={onInputChange}
					ref={fileInputRef}
				/>

				{image && (
					<button
						type="button"
						className="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y text-light"
						style={{ textDecoration: "none" }}
						onClick={handleClear}
						aria-label="Clear image"
					>
						<i className="bi bi-x-circle" style={{ fontSize: "1.2rem" }} />
					</button>
				)}
			</div>

			<div className="mt-2">
				<img
					src={previewUrl || savedImage || "/images/placeholder.png"}
					alt="Preview"
					className="img-fluid rounded"
					style={{ maxHeight: "200px", objectFit: "cover" }}
				/>
			</div>
		</div>
	);
}
